import React from 'react';
import { Button, Descriptions, Icon } from 'antd';
import { countSmsSegments } from '../../Utils';
import TEXTS from '../../locale/texts';
import { PREVIEW_CAMPAIGN, SHOW_MSISDNS } from '../../config/constants';
import moment from 'moment';

const CampaignPreview = (props) => {
  const {
    isEdit,
    hideDrawer,
    showDrawer,
    previewData: campaign,
    // createDraftCampaign
    createDraftCampaign,
    createDraftCampaignsIsLoading,
    // crateAndSendCampaign
    createAndSendCampaign,
    createAndSendCampaignsIsLoading,
    // updateDraftCampaign
    updateDraftCampaign,
    updateDraftCampaignsIsLoading,
    sendCampaignIsLoading,
    lang
  } = props;

  const {
    name,
    scheduleTime,
    msisdns,
    sender,
    smsBody,
    isMsisdnsWithData
  } = campaign;

  const saveIsLoading = createDraftCampaignsIsLoading || updateDraftCampaignsIsLoading;
  const sendIsLoading = createAndSendCampaignsIsLoading || sendCampaignIsLoading;
  const globalDisable = saveIsLoading || sendIsLoading;

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="t-light" style={{position: 'relative'}}>
          {name}
          {isMsisdnsWithData &&
            <p style={{margin: 0, fontSize: 14}}>
              {TEXTS.campaignIsWithMsisdnsData[lang]}
              <Icon
                type="solution"
                style={{position: 'relative', top: -2, marginLeft: 5, fontSize: 14}}
              />
            </p>}
        </h3>
        <div>
          <Button
            type="primary"
            size="large"
            style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
            loading={sendIsLoading}
            disabled={globalDisable}
            onClick={() => {
              // always create new campaign
              // because method sendCampaign
              // does not save changes
              // does not receive body
              createAndSendCampaign();
              // if (isEdit) {
              //   sendCampaign();
              // } else {
              //   createAndSendCampaign();
              // }
            }}
          >
            {TEXTS.btnSendCampaign[lang]}
          </Button>

          {/*<button*/}
            {/*type="submit"*/}
            {/*className={`btn btn-small btn-purple mr-3${sendIsLoading ? ' is-loading' : ''}${globalDisable ? ' disabled' : ''}`}*/}
            {/*onClick={() => {*/}
              {/*// always create new campaign*/}
              {/*// because method sendCampaign*/}
              {/*// does not save changes*/}
              {/*// does not receive body*/}
              {/*createAndSendCampaign();*/}
              {/*// if (isEdit) {*/}
              {/*//   sendCampaign();*/}
              {/*// } else {*/}
              {/*//   createAndSendCampaign();*/}
              {/*// }*/}
            {/*}}*/}
          {/*>*/}
            {/*{sendIsLoading*/}
              {/*&& <Icon type="loading" />}*/}
            {/*{TEXTS.btnSendCampaign[lang]}*/}
          {/*</button>*/}

          <Button
            type="primary"
            size="large"
            style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
            loading={saveIsLoading}
            disabled={globalDisable}
            onClick={() => {
              if (isEdit) {
                updateDraftCampaign()
              } else {
                createDraftCampaign()
              }
            }}
          >
            {TEXTS.btnSaveDraftCampaign[lang]}
          </Button>

          <Button
            style={{padding: '0 20px', height: 40, marginRight: 15, fontSize: 14}}
            disabled={globalDisable}
            onClick={hideDrawer}
          >
            {TEXTS.btnCancel[lang]}
          </Button>
        </div>
      </div>
      <Descriptions bordered column={1} size="middle">
        <Descriptions.Item label={TEXTS.campaignSenderLabel[lang]}>
          {sender}
        </Descriptions.Item>
        <Descriptions.Item label={TEXTS.thSmsBody[lang]}>
          <span style={{whiteSpace: 'pre-line'}}>
            {smsBody}
          </span>
        </Descriptions.Item>
        <Descriptions.Item label={TEXTS.campaignDatePlaceholder[lang]}>
          {scheduleTime
            ? moment(scheduleTime).format('DD.MM.YYYY HH:mm:ss')
            : TEXTS.campaignSendNow[lang]}
        </Descriptions.Item>
        <Descriptions.Item label={TEXTS.thReceiversCount[lang]}>
          {msisdns && msisdns.length}
          <Button
            style={{
              verticalAlign: 'middle',
              marginLeft: 10
            }}
            onClick={() => showDrawer(SHOW_MSISDNS, PREVIEW_CAMPAIGN)}
          >
            <Icon type="unordered-list" style={{position: 'relative', top: -4}} />
            {TEXTS.showMsisdnList[lang]}
          </Button>
        </Descriptions.Item>
        <Descriptions.Item label={TEXTS.numberOfPosts[lang]}>
          {msisdns && msisdns.length}
        </Descriptions.Item>
        <Descriptions.Item label={TEXTS.campaignSmsBodySegmentsCount[lang]}>
          {countSmsSegments(smsBody)}
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default CampaignPreview;
